import { render, staticRenderFns } from "./solar-terms-poster.vue?vue&type=template&id=5418f626&scoped=true&"
import script from "./solar-terms-poster.vue?vue&type=script&lang=js&"
export * from "./solar-terms-poster.vue?vue&type=script&lang=js&"
import style0 from "./solar-terms-poster.vue?vue&type=style&index=0&id=5418f626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418f626",
  null
  
)

export default component.exports